<template>
  <div>
    <DeleteViolationModal
      :violation="toBeDeletedViolation"
      @deleted="fetchViolations"
    />
    <div
      v-if="$can('write', 'violations')"
      class="d-flex justify-content-between mb-2"
    >
      <b-button
        variant="primary"
        @click="$router.push('/violations/new')"
      >
        Create Rule
      </b-button>
    </div>
    <b-card>
      <b-overlay
        variant="white"
        spinner-variant="primary"
        blur="0"
        opacity=".75"
        rounded="sm"
        :show="loading"
      >
        <b-table
          fixed
          :fields="tableColumns"
          :items="violations"
          class="mb-2 text-center"
          empty-text="No violations rules yet"
          show-empty
        >
          <template #cell(actions)="data">
            <b-dropdown
              variant="link"
            >

              <template #button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="align-middle text-body"
                />
              </template>

              <b-dropdown-item
                v-if="$can('write', 'violations')"
                @click="$router.push(`/violations/${data.item.id}`)"
              >
                <feather-icon icon="EditIcon" />
                <span class="align-middle ml-50">Edit</span>
              </b-dropdown-item>
              <b-dropdown-item
                v-if="$can('delete', 'violations')"
                @click="openDeleteModal(data.item)"
              >
                <feather-icon icon="TrashIcon" />
                <span class="align-middle ml-50">Delete</span>
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </b-table>
      </b-overlay>
    </b-card>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api'
import {
  BButton, BTable, BCard, BOverlay, BDropdown, BDropdownItem,
} from 'bootstrap-vue'
import formatDate from '@/utils/date-format'
import DeleteViolationModal from './DeleteViolationModal.vue'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import store from '../driverStoreModule'

export default {
  components: {
    BButton, BTable, BCard, BOverlay, BDropdown, BDropdownItem, DeleteViolationModal,
  },
  setup(props, ctx) {
    useRegisterStoreModule('drivers', store)

    const tableColumns = [
      {
        label: 'Name English',
        key: 'name',
      },
      {
        label: 'Name Arabic',
        key: 'name_ar',
      },
      {
        label: 'created at',
        key: 'created_at',
        formatter: val => formatDate(val),
      },
      'actions',
    ]

    const violations = ref([])
    const loading = ref(false)
    const fetchViolations = async () => {
      loading.value = true
      const result = await ctx.root.$store.dispatch('drivers/fetchViolationTypes')
      const { data } = result.data
      violations.value = data
      loading.value = false
    }

    fetchViolations()

    const toBeDeletedViolation = ref()
    const openDeleteModal = violation => {
      toBeDeletedViolation.value = violation
      ctx.root.$bvModal.show('delete-violation-modal')
    }
    return {
      tableColumns,
      loading,
      toBeDeletedViolation,
      violations,
      openDeleteModal,
      fetchViolations,
    }
  },
}
</script>

  <style>

  </style>
